import { Injectable } from '@angular/core';
import { DocumentDataService } from '../data-services/document-data.service';

@Injectable({ providedIn: 'root' })
export class DocumentService {
    constructor(
        private documentDataService: DocumentDataService
    ) { }

    DownloadDeliveryNote(model: any) {
        return this.documentDataService.DownloadDeliveryNote(model);
    }
    DownloadWarrantyDocument(model: any) {
        return this.documentDataService.DownloadWarrantyDocument(model);
    }
    SendWarrantyDocument(model: any) {
        return this.documentDataService.SendWarrantyDocument(model);
    }
    DownloadSignedWarrantyDocument(model: any) {
        return this.documentDataService.DownloadSignedWarrantyDocument(model);
    }
    WarrantyDocumentStatus(workOrderNo: any,dealerId: any) {
        return this.documentDataService.WarrantyDocumentStatus(workOrderNo,dealerId);
    }
    GetPendingSignDocument(workOrderNo: any) {
        return this.documentDataService.GetPendingSignDocument(workOrderNo);
    }
    DownloadOrderDocument(model: any) {
        return this.documentDataService.DownloadOrderDocument(model);
    }
}